import React from "react";
import { ComponentPropsFromRoute } from "../../../routers/routers";
import {RouteTabs} from "../../common/route-tabs/route.tabs";

export const SettingsCommon: React.FC<ComponentPropsFromRoute> = ({ routeChildren }) => {

    return <RouteTabs
        routes={routeChildren!}
    />
}